<style src="./EditUser.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="edit-user">
    <form
      @submit.prevent="submitForm"
      class="row">
      <textbox
        class="col-12"
        :autofocus="true"
        label="Nome do usuário"
        placeholder="Ex.: João Alberto de Almeida"
        v-model="form.name" />

      <textbox
        class="col-12"
        label="Apelido de identificação"
        placeholder="Ex.: JoãoAlberto"
        v-model="form.username" />

      <password
        class="col-12"
        label="Senha"
        placeholder="Ex.: @Ghfg!@"
        v-model="form.password" />

      <dropdown
        class="col-12"
        label="Permissão"
        placeholder="Escolha..."
        v-model="form.permission"
        :list-data="listPermissions"/>

      <dropdown
        class="col-12"
        label="Ocupação"
        placeholder="Escolha..."
        v-model="form.occupation"
        :list-data="listOccupations"/>

      <stage-checker
        class="col-12"
        label="Responsabilidades"
        placeholder="Escolha..."
        v-model="form.stages"
        :list-data="listStages"/>

      <div class="commands col-12">
        <button-submit
          class="col-5"
          label="Salvar Usuário"
          :state="commands.submitState"
          :icon-save="commands.saveIcon"/>

        <button
          class="btn-ghost col-5 cancel-button"
          type="button"
          @click="closePanel">
          <icon-close />
          Cancelar
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import { Textbox, Password, Dropdown, ButtonSubmit } from '@/components/primitives'
import { IconClose, IconSave } from '@/components/primitives/icons'
import { ListPermissions, ListOccupations, ListStages } from '../../NewUserHelper'
import { EditUser } from '@/brain/record/user'
import { StageChecker } from '../../components'

export default {
  name: 'EditUser',
  components: {
    StageChecker,
    Textbox,
    Password,
    Dropdown,
    ButtonSubmit,
    IconSave,
    IconClose
  },
  props: {
    editData: {
      default: null
    }
  },
  data () {
    return {
      saveDisabled: false,
      form: {
        name: '',
        username: '',
        password: '',
        permission: '',
        occupation: '',
        stages: []
      },
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      },
      listPermissions: [],
      listOccupations: [],
      listStages: []
    }
  },
  mounted () {
    this.fillData()
    ListStages()
      .then((stageList) => {
        this.listStages = stageList
      })
    ListPermissions()
      .then((pPermissionList) => {
        this.listPermissions = pPermissionList
      })
    ListOccupations()
      .then((pOccupationList) => {
        this.listOccupations = pOccupationList
      })
  },
  methods: {
    fillData () {
      if (this.editData !== null) {
        this.form.name = this.editData.name
        this.form.username = this.editData.username
        this.form.password = ''
        this.form.occupation = this.editData.occupation
        this.form.permission = this.editData.permission
        this.form.stages = this.editData.board.stageResponsible
      }
    },
    submitForm () {
      this.commands.submitState = 'WAIT'
      const data = {
        _id: this.editData._id,
        name: this.form.name,
        username: this.form.username,
        password: this.form.password,
        occupation: this.form.occupation.value || this.form.occupation,
        permission: this.form.permission.value || this.form.permission,
        responsabilities: this.form.stages
      }
      EditUser(data)
        .then((response) => {
          this.$emit('refresh-list')
          this.clearForm()
          this.commands.submitState = 'REPOSE'
          this.$parent.$emit('close', false)
        })
    },
    closePanel () {
      this.$parent.$emit('close', false)
    },
    clearForm () {
      this.form.name = ''
      this.form.username = ''
      this.form.password = ''
      this.form.occupation = ''
      this.form.permission = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/user/right-panel/edit-user/EditUser.vue